/* eslint-disable prettier/prettier */
import { useCallback, useEffect, useState } from 'react';

import { goalService, Goal } from '../services/goalService';

export const useGoalList = (filters: {
	userid?: string;
	programid?: string;
	istemplate?: boolean;
	status?: string;
	createdby?: string;
	page?: number;
	limit?: number;
}) => {
	const [goals, setGoals] = useState<Goal[]>([]);

	const [total, setTotal] = useState(0);

	const [loading, setLoading] = useState(false);

	const [error, setError] = useState<string | null>(null);

	const fetchGoals = useCallback(async () => {
		try {
			setLoading(true);
			setError(null);

			const response = await goalService.getGoals(filters);

			setGoals(response.goals);
			setTotal(response.total);
		} catch (err: any) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}, [filters]);

	useEffect(() => {
		fetchGoals();
	}, [fetchGoals]);

	return {
		goals,
		total,
		loading,
		error,
		refetch: fetchGoals,
	};
};
